import React from 'react';
import { CardPreviewPane } from './components/PremiumDigitalCustomizationContent/PremiumDigitalPreviewPane';
import { useIsMobileOrTablet } from '@shared/utils/media/useMediaScreens';

import { PremiumDigitalCustomizationPane } from './components/PremiumDigitalCustomizationContent/PremiumDigitalCustomizationPane';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import { PdpLayout } from './components/PdpLayout/PdpLayout';
import { usePriceSummary } from '@apps/card/components/PriceSummary/usePriceSummary';
import { BasePdpImplementationProps } from './ProductDetailsPage';
import { StationeryTemplatePDP } from './ProductDetailsPage.types';
import { MinimalRequiredTemplateDataForDraft } from '../DesignsGallery/DesignsGallery.types';

interface PremiumDigitalPdpProps extends BasePdpImplementationProps {
  template: StationeryTemplatePDP;
  onCustomizeClick: (template: MinimalRequiredTemplateDataForDraft, subtotalInMinorUnits?: number) => void;
}
export const PremiumDigitalPdp = (props: PremiumDigitalPdpProps) => {
  const { productSelector, intersectionRef, isCreatingDraft, onCustomizeClick, showCustomizeButtonInHeader, template, designName, templateCategory, eventId, isFoil } = props;

  const themeJson = template.themeJSON;

  const isMobileOrTablet = useIsMobileOrTablet();

  const { totalInMinorUnits } = usePriceSummary({ templateCategory, priceUpTo: 'cardFront', cardConfig: template.themeJSON });

  const handleOnCustomizeNowClick = useEventCallback(() => {
    onCustomizeClick(template, totalInMinorUnits);
  });

  return (
    <PdpLayout
      themeId={template.themeId}
      isFoil={isFoil}
      designName={designName}
      isPremium={template.premium}
      templateCategory={templateCategory}
      onCustomizeNowClick={handleOnCustomizeNowClick}
      isCreatingDraft={isCreatingDraft}
      productSelector={productSelector}
      showCustomizeButtonInHeader={showCustomizeButtonInHeader}
      previewPane={() => (
        <CardPreviewPane
          eventId={eventId}
          templateId={template.id}
          isFavorite={template.isFavorite}
          templateCategory={templateCategory}
          cardFront={themeJson.card.front}
          cardShape={themeJson.customizations.shape}
          cardJson={themeJson}
          thumbnailUrl={template.thumbnailUrl!}
          themeId={template.themeId}
        />
      )}
      customizationPane={() => (
        <PremiumDigitalCustomizationPane
          category={templateCategory}
          themeId={template.themeId}
          hideCustomizeNowButton={isMobileOrTablet}
          intersectionRef={intersectionRef}
          isCreatingDraft={isCreatingDraft}
          onCustomizeClick={handleOnCustomizeNowClick}
        />
      )}
    />
  );
};
